import React, { useState } from "react"

import DatePicker from "react-multi-date-picker"

import CloseButton from "./Plugins/CloseButton"

const Picker = ({ value, onChange, fixed = false, ...props }) => {
  const [datePickerClosed, setDatePickerClosed] = useState(true)

  const containerStyle = { display: "block" }
  if (fixed) {
    containerStyle.position = "fixed"
    containerStyle.zIndex = 100
  }

  return (
    <DatePicker
      value={value}
      onChange={onChange}
      onOpen={() => setDatePickerClosed(false)}
      onClose={() => datePickerClosed}
      format="M/D/YYYY"
      containerStyle={containerStyle}
      inputClass="form-control"
      editable={false}
      plugins={[
        <CloseButton
          key="closeButton"
          position="bottom"
          setClosed={setDatePickerClosed}
        />,
      ]}
      {...props}
    />
  )
}

export default Picker
